import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { StaffPreferences } from '@fitness-force/enum';
import { StaffNotification, TENANTSINTERFACE } from '@fitness-force/models';
import { Store } from '@ngrx/store';
import { TENANTS_INFO } from 'apps/ff-frontend/src/app/state/app.state';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { DrawerModule } from 'primeng/drawer';
import { StaffNotificationComponent } from 'libs/shared/src/lib/components/staff-notification/staff-notification.component';
import { StaffAvailabilityComponent } from '@fitness-force/staff-availability-lib';
import { TranslateModule } from '@ngx-translate/core';
import { StaffDetailsComponent } from 'libs/staff-lib/src/lib/components/staff-details/staff-details.component';
import { SelectModule } from 'primeng/select';


@Component({
  selector: 'staff-preferences',
  standalone: true,
  imports: [
    CommonModule,
    DrawerModule,
    ToggleSwitchModule,
    FormsModule,
    ReactiveFormsModule,
    StaffNotificationComponent,
    StaffAvailabilityComponent,
    TranslateModule,  
    SelectModule,
    StaffDetailsComponent
  ],
  templateUrl: './staff-preferences.component.html',
  styleUrl: './staff-preferences.component.css',
})
export class StaffPreferencesComponent implements OnInit {
  @Input('showClientSidebar') showStaffPreferenceSidebar: boolean = false;
  @Input('activeStaffId') activeStaffId: number = 0;
  @Input('staffPreferences') staffPreference: StaffPreferences = StaffPreferences.Profile;
  @Output('closeSidebar') closeSidebar: EventEmitter<boolean> = new EventEmitter();

  staffSubscribedNotification: StaffNotification = {} as StaffNotification;
  allNotifications: { key: string; label: string }[] = [];
  tenantAccess: any[] = [];
  tenantId: number = 0;
  companyId:number = 0;
  selectedPreference: StaffPreferences = this.staffPreference;
  showNotification: boolean = true;
  preferences: any[] = [];
  selectedPreferenceOption: any;
  constructor(
    public cdr: ChangeDetectorRef,
    private store: Store
  ) {
    this.preferences = [
      {name: 'PROFILE', icon: 'fa fa-user', value: StaffPreferences.Profile, disabled: false},
      {name: 'NOTIFICATION', icon: 'fa fa-bell', value: StaffPreferences.Notification, disabled: false},
      {name: 'AVAILABILITY', icon: 'fa fa-calendar-days', value: StaffPreferences.Availability, disabled: false},
      {name: 'LANGUAGE', icon: 'fa fa-language', value: StaffPreferences.Language, disabled: true},
    ]
  }

  ngOnInit() {
    this.store.select(TENANTS_INFO).subscribe((tenant: TENANTSINTERFACE) => {
      this.tenantAccess = tenant.accessed_tenant;
      this.tenantId = tenant.selected_tenant.id;
      this.companyId= tenant.selected_tenant.company_id;
    });
    //  if (Statsig.checkGate("enable_staff_desktop_notification"))
    //   {
    //     this.showNotification =true;
    //   }
    //   else{
    //     this.showNotification =false;
    //   }
      this.selectedPreferenceOption = this.preferences.find(preference => preference.value === this.selectedPreference);
  }

  selectPreferenceMobile(preference: any){
    var selectedpref = preference.value;
    this.selectedPreferenceOption = selectedpref;
    this.selectedPreference = selectedpref.value;
    this.cdr.detectChanges();
  }

  selectPreferenceDesktop(preference: any){
    this.selectedPreferenceOption = preference;
    this.selectedPreference = preference.value;
    this.cdr.detectChanges();
  }
  
  close() {
    this.showStaffPreferenceSidebar=false;
    this.closeSidebar.emit(true);
  }

  public get staffPreferences(): typeof StaffPreferences {
    return StaffPreferences;
  }

}
